<div class="mt-3 d-flex justify-content-center col-12">
  <div class="login-version-alert">
      Version: {{appVersion}}
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/login-show-app-version/login-show-app-version.component.html